export const SET_CURRENT_PLAYER = 'SET_CURRENT_PLAYER';

export const setCurrentPlayer = (playerId) => ({
    type: SET_CURRENT_PLAYER,
    payload: playerId,
})
